import React from "react";
import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import ProjectCard from "./ProjectCard";
import projImg01 from "../assets/img/netflix.png"
import projImg1 from "../assets/img/wcs.png";
import projImg2 from "../assets/img/snake catching food game.png";
import projImg3 from "../assets/img/calculator.png";
import projImg4 from "../assets/img/todolist.png";
import projImg5 from "../assets/img/Tour&Tourism.png";
import projImg6 from "../assets/img/MenuCard.png";
import projImg7 from "../assets/img/shopping-site.png";
import projImg8 from "../assets/img/cashback.png";
import projImg9 from "../assets/img/enhancement.png";
import projImg0 from "../assets/img/food-ordering.jpg";
import projImgYt from "../assets/img//youtube.png";
import colorSharp2 from "../assets/img/color-sharp2.png";
import "animate.css";
import TrackVisibility from "react-on-screen";

export default function Projects() {
  const projects = [
    {
      id: "project0",
      title: "Netflix Clone - GPT",
      description:
        "Netflix clones with Authentication functionality,TDMB Api, Redux store, hooks, by using the all things build Netflix working responsive clone, which includes GPT search(OpenAI API) functionality code.",
      imgUrl: projImg01,
    },
    {
      id: "youtube",
      title: "Youtube Clone",
      description:
        "Youtube Clone with display content with Live API Using functionality like API Polling to show Live chat section,Debouncing, Redux Store and using of Hooks, LLD Design.",
      imgUrl: projImgYt,
    },
    {
      id: "project1",
      title: "Food Ordering app Clone",
      description:
        "Using Swiggy's Live API Created the working clone in which we can check the food card add to cart, searching, Top Rated this functionality added, hooks",
      imgUrl: projImg0,
    },
    {
      id: "project3",
      title: "Snake Catching food",
      description: "Can be play without internet for hours for High score",
      imgUrl: projImg2,
    },
    {
      id: "project4",
      title: "Calculator using JavaScript",
      description:
        "Calculator with all Functionality such as addition, subtraction, multiplication and division, decimal point or without decimal point",
      imgUrl: projImg3,
    },
    {
      id: "project5",
      title: "Todolist using react ",
      description:
        "Using The To-do we can list the Note & Tasks , The main thing is use of local storage so that whenever refresh the date will kept as it is.",
      imgUrl: projImg4,
    },
  ];
  const projectTwo = [
    {
      id: "project2",
      title: "Web Calling Sequential Dialing",
      description:
        "Using the SDK implementation in the admin panel for calling service through the web admin panel",
      imgUrl: projImg1,
    },
    {
      id: "project9",
      title: "CashBack in Account",
      description:
        "After a certain transaction, the user should get some cashback to his account.",
      imgUrl: projImg8,
    },
    {
      id: "project10",
      title: "UI Enhancement",
      description:
        "UI Enhancement in which the full home page UI is changed as per the Product team requirement",
      imgUrl: projImg9,
    },
    
  ];
  const projectTree = [
    {
      id: "project8",
      title: "Shoping Site MiniProject UI ",
      description:
        "Showing the different products by category and full shopping display page. Roll: Developer | Tech : HTML, CSS , Bootstrap.",
      imgUrl: projImg7,
    },
    {
      id: "project6",
      title: "real-estate responsive design",
      description:
        "Different City project guide, registration, login form and info about it.",
      imgUrl: projImg5,
    },
    {
      id: "project7",
      title: "Restaurant MenuCard",
      description:
        "Shows the Menu by the time breakfast,lunch,evening,dinner. Role:Developer | Tech : React Js",
      imgUrl: projImg6,
    },
  ];
  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <h2>Projects</h2>
                  <p>
                    Work on several projects includes some mini projects and
                    some product-based company projects. Some of the projects
                    listed below. In which React JS, Bootstrap, HTML,CSS and
                    JavaScript, Go,JsSIP Liabrary, are used.
                  </p>
                  <Tab.Container id="projects-tabs" defaultActiveKey="first">
                    <Nav
                      variant="pills"
                      className="nav-pills mb-5 justify-content-center align-items-center"
                      id="pills-tab"
                    >
                      <Nav.Item>
                        <Nav.Link eventKey="first">Own Projects</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="second">Org Projects</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="third">Own Projects</Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <Tab.Content
                      id="slideInUp"
                      className={
                        isVisible ? "animate__animated animate__slideInUp" : ""
                      }
                    >
                      <Tab.Pane eventKey="first">
                        <Row>
                          {projects.map((project, index) => {
                            return <ProjectCard key={project.id} {...project} />;
                          })}
                        </Row>
                      </Tab.Pane>
                      <Tab.Pane eventKey="second">
                        <Row>
                          {projectTwo.map((project, index) => {
                            return <ProjectCard key={index} {...project} />;
                          })}
                        </Row>
                      </Tab.Pane>
                      <Tab.Pane eventKey="third">
                        <Row>
                          {projectTree.map((project, index) => {
                            return <ProjectCard key={index} {...project} />;
                          })}
                        </Row>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  );
}
